export default {
  de: {
    caption: "Benutzerrechte",
    viewTitle: "Lesen",
    editTitle: "Bearbeiten",
    viewDesc: "Leserechte des Services",
    editDesc: "Bearbeitungsrechte des Services",
    roles: "Gruppen",
    rolesAssign: "Gruppenzuweisung",
    user: "Benutzer",
    deleteRole: "Gruppe löschen",
    deleteUser: "Benutzer löschen",
    missingRights: "Nicht alle Rechte vorhanden",
    notification: {
      edit: {
        type: 'success',
        message: 'Gruppe erolgreich gespeichert',
        title: 'Erfolgreich gespeichert'
      }
    }
  }
}
